import { UserInterface } from "@swivl-mono/types";
import { parseFullName } from "parse-full-name";

interface HasName {
  name: string;
}
export class NameHelper {
  static parseFullName(user: HasName) {
    return parseFullName(user.name);
  }
  static setFirstName(user: HasName, firstName: string) {
    const parsed = parseFullName(user.name);
    return `${firstName}${parsed.middle ? " " + parsed.middle : ""}${parsed.last ? " " + parsed.last : ""}`;
  }
  static setLastName(user: HasName, lastName: string) {
    const parsed = parseFullName(user.name);
    return `${parsed.first ? " " + parsed.first : ""} ${parsed.middle ? " " + parsed.middle : ""}${lastName}`;
  }

  static getFirstName(user: HasName) {
    return parseFullName(user.name).first || user.name;
  }

  static getLastName(user: HasName) {
    return parseFullName(user.name).last || user.name;
  }

  static nameForUser(user?: UserInterface) {
    if (!user) {
      return "Unknown User";
    }
    if (user.name && user.name !== "") {
      return user.name.trim();
    }
    if (user.number) {
      return `User ${user.number}`;
    }
    if (user.id) {
      return `User ${user.id}`;
    }
    return "Unknown User";
  }
}
